import React from 'react';

import EditModalContainer from 'features/vip/containers/EditModalContainer';
import {get, formatDollars} from 'utils/helpers';
import {TileStyled} from 'features/generic/components/Tile/Tile';

import * as styles from './styles';
import {TooltipBox, TooltipCardCounts, TooltipText, TableCellCss} from './styles';
import {
    TableCellStyled,
    TableHeaderCell,
    TableHeaderRowStyled,
    TableRowStyled,
} from 'features/generic/components/Table/Table';
import {COLORS} from 'core/styles';

const VipPackage = (props) => {
    const packages = props.packagesByRegion;

    const showPackages = props.attach ? props.attaching : true;

    const columns = [
        {
            flex: 0.75,
            HeaderComponent: () => <span>State</span>,
            ChildComponent: (props) => <>{props?.pkg?.region?.name}</>,
        },
        {
            flex: 0.75,
            HeaderComponent: () => <span>Count</span>,
            ChildComponent: (props) => (
                <>
                    <TooltipCardCounts>
                        <TooltipText>
                            <div>{props?.pkg?.subscription_counts?.active}</div>
                        </TooltipText>
                        <TooltipBox>
                            {props?.pkg?.subscription_counts?.active} of 8 active
                            subscriptions
                        </TooltipBox>
                    </TooltipCardCounts>
                </>
            ),
        },
        {
            flex: 0.75,
            HeaderComponent: () => <span>Cost</span>,
            ChildComponent: (props) => <>{formatDollars(get(props?.pkg, 'base_price'))}</>,
        },
    ];

    return (
        <>
            {props.attach && (
                <div style={styles.header}>
                    <div className="h3">Packages</div>
                    {props.attach && !props.attaching && (
                        <div style={styles.attach} onClick={props.handleToggleAttach}>
                            + Attach Package
                        </div>
                    )}
                </div>
            )}
            <TileStyled $css={props.$css} className={props.className}>
                <TableHeaderRowStyled>
                    {columns.map((column, i) => (
                        <TableHeaderCell key={i} flex={column.flex}>
                            <column.HeaderComponent />
                        </TableHeaderCell>
                    ))}
                </TableHeaderRowStyled>
                {showPackages &&
                    packages.map((section) => {
                        const pkg = section.values[0];
                        const counts = pkg.subscription_counts;
                        const unavailable = counts.active >= 8;
                        return (
                            <TableRowStyled
                                key={section.key}
                                onClick={() =>
                                    !unavailable &&
                                    props.attach &&
                                    props.handleAttach(pkg.id)
                                }
                                style={
                                    props.attach
                                        ? {
                                              cursor: 'pointer',
                                              color: COLORS.primary,
                                              fontWeight: 'bold',
                                              textDecoration: 'underline',
                                          }
                                        : {}
                                }>
                                {columns.map((column, i) => (
                                    <TableCellStyled
                                        $css={TableCellCss}
                                        flex={column.flex}
                                        key={i}>
                                        <column.ChildComponent
                                            pkg={pkg}
                                            attach={props.attach}
                                        />
                                    </TableCellStyled>
                                ))}
                            </TableRowStyled>
                        );
                    })}
                {props.activeModalId && (
                    <EditModalContainer
                        packageId={props.activeModalId}
                        handleClose={() => props.handleAttach(props.activeModalId)}
                    />
                )}
            </TileStyled>
        </>
    );
};

export default VipPackage;
